module.exports = __webpack_public_path__ + "static/img/shumachanpin.1ca944f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shumachanpin.png
// module id = yvEf
// module chunks = 0